import objectHash from 'object-hash'
import createRouteStoreId from 'root/src/client/logic/route/util/createRouteStoreId'

export default (routeObj, endpointId, moduleId, filters = {}) => `${
	createRouteStoreId(routeObj)}${
	moduleId ? `---${moduleId}` : ''}---${
	endpointId}---${
	objectHash({ filters })}`
